var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStaffRequestResourcePageIcons2 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.0039,
  cy: 12,
  r: 12,
  fill: "url(#paint0_linear_50334_80302)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.8869 5.60938H7.23599C6.95351 5.60938 6.6826 5.72159 6.48286 5.92133C6.28311 6.12108 6.1709 6.39198 6.1709 6.67446V17.3254C6.1709 17.6078 6.28311 17.8787 6.48286 18.0785C6.6826 18.2782 6.95351 18.3904 7.23599 18.3904H17.8869C18.1694 18.3904 18.4403 18.2782 18.64 18.0785C18.8397 17.8787 18.952 17.6078 18.952 17.3254V6.67446C18.952 6.39198 18.8397 6.12108 18.64 5.92133C18.4403 5.72159 18.1694 5.60938 17.8869 5.60938ZM10.0545 10.0255L12.1847 7.89532C12.2341 7.84581 12.2928 7.80653 12.3575 7.77973C12.4221 7.75293 12.4914 7.73913 12.5614 7.73913C12.6314 7.73913 12.7007 7.75293 12.7654 7.77973C12.83 7.80653 12.8887 7.84581 12.9382 7.89532L15.0684 10.0255C15.1179 10.075 15.1571 10.1337 15.1839 10.1984C15.2107 10.263 15.2244 10.3323 15.2244 10.4023C15.2244 10.4722 15.2107 10.5415 15.1839 10.6062C15.1571 10.6708 15.1179 10.7296 15.0684 10.779C15.0189 10.8285 14.9602 10.8678 14.8955 10.8946C14.8309 10.9213 14.7616 10.9351 14.6916 10.9351C14.6216 10.9351 14.5523 10.9213 14.4877 10.8946C14.4231 10.8678 14.3643 10.8285 14.3148 10.779L13.094 9.55753V13.5975C13.094 13.7388 13.0379 13.8742 12.938 13.9741C12.8381 14.074 12.7027 14.1301 12.5614 14.1301C12.4202 14.1301 12.2847 14.074 12.1849 13.9741C12.085 13.8742 12.0289 13.7388 12.0289 13.5975V9.55753L10.808 10.779C10.7081 10.879 10.5726 10.9351 10.4313 10.9351C10.2899 10.9351 10.1544 10.879 10.0545 10.779C9.95455 10.6791 9.89841 10.5436 9.89841 10.4023C9.89841 10.261 9.95455 10.1254 10.0545 10.0255ZM17.8869 17.3254H7.23599V14.6626H9.14582L10.4313 15.9481C10.5298 16.0474 10.6471 16.1261 10.7764 16.1797C10.9056 16.2333 11.0442 16.2607 11.1841 16.2603H13.9387C14.0786 16.2607 14.2173 16.2333 14.3465 16.1797C14.4758 16.1261 14.5931 16.0474 14.6916 15.9481L15.977 14.6626H17.8869V17.3254Z",
  fill: "white"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_50334_80302",
  x1: 6.50391,
  y1: 1,
  x2: 16.0039,
  y2: 23,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B6D8B1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D6E28D"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStaffRequestResourcePageIcons2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/staff_request_resource_page_icons2.9686c7223786b3936ce133032b6f976c.svg";